// Directory layout (Filter + Browse)
// 

JLM.MD.Directory = function( container, division_type ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let layout;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		if ( division_type == JLM.NS.DIVISION_CONTENT_CREATORS ) {
			layout = new JLM.MD.TalentBrowseGroups( container, division_type );
		} else {
			layout = new JLM.MD.TalentBrowse( container, division_type );
		}
		
		// Events
		layout.on('shortlist_remove', function() {
			INSTANCE.dispatchEvent('shortlist_remove', [].slice.call( arguments ));
		});
		layout.on('shortlist_add', function() {
			INSTANCE.dispatchEvent('shortlist_add', [].slice.call( arguments ));
		});
		
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	INSTANCE.expand = function() {
		container.addClass('expand');
	};
	INSTANCE.contract = function() {
		container.removeClass('expand');
	};
	INSTANCE.removeFromShortlist = function( talent_id, division ) {
		layout.removeFromShortlist( talent_id, division );
	};
	INSTANCE.emptyShortlist = function() {
		layout.emptyShortlist();
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};